module.exports = __webpack_public_path__ + "static/media/count25Off_326.d93fd7d6.png";